import { PaymentService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { billingKeys } from './billingKeys';
import type { TCall } from '../types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof billingKeys.memberPaymentMethodsByAccount>>;

export const createFetchMemberPaymentMethodsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ baId }], signal }: TParams) =>
    call(() => cancelOnSignal(PaymentService.billingAccountPaymentMethodList({ baId }), signal));
